module.exports = __webpack_public_path__ + "static/media/I_am_deeply_hypnotized.76fcdfd1.mp3";